import {
  getAiSCampaignInformation,
  getAiSCampaignInformationDummyData,
  getShortCampaignSamlpeData,
} from '../config/server-config';
import { TokenDecode } from './general-util';
import { readFromCache, writeToCache } from './cache-util';
import { API_CALL_SUCCESSFULL, NUMBER_TWO, NUMBER_FOUR } from '../constants/NumberConstants';
import { ACTIVIST_SHORTS } from '../constants/ProductConstants';
import api from '../api';

export const GetAiSCampaignInformation = async (req) => {
  try {
    const cachedData = readFromCache(getAiSCampaignInformation);
    const token = localStorage.getItem('token');
    // if (cachedData) {
    //   return cachedData;
    // }
    const response = await api.post(
      getAiSCampaignInformation,
      {
        product_id: ACTIVIST_SHORTS,
        token,
      },
      {
        cancelToken: req.cancelToken,
      },
    );
    writeToCache(getAiSCampaignInformation, response.data);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
    return [];
  } catch (e) {
    return false;
  }
};

export const GetAiSCampaignInformationDummyData = async (req) => {
  try {
    const cachedData = readFromCache(getAiSCampaignInformationDummyData);

    // if (cachedData) {
    //   return cachedData;
    // }
    const response = await api.post(
      getAiSCampaignInformationDummyData,
      {},
      {
        cancelToken: req.cancelToken,
      },
    );
    writeToCache(getAiSCampaignInformationDummyData, response.data);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
    return [];
  } catch (e) {
    return false;
  }
};

export const ShortCampaignDataandAnalyticsReq = async (productId) => {
  // TokenDecode() resolves to undefined when the token is missing/invalid (it redirects to login),
  // so guard against an absent token and an absent membership entry rather than dereferencing them.
  const dToken = await TokenDecode();
  const membership = Array.isArray(dToken?.MemberShip) ? dToken.MemberShip : [];
  const entry = membership.find((item) => item.product_id === productId);

  // Default to the most restricted (trial) view when the product/membership cannot be resolved.
  if (!entry) {
    return { productId, trialStatus: true, displayLimitedData: true };
  }

  if (entry.status === NUMBER_FOUR) {
    return { productId, trialStatus: false, displayLimitedData: false };
  }
  if (entry.status === NUMBER_TWO) {
    return { productId, trialStatus: false, displayLimitedData: true };
  }
  return { productId, trialStatus: true, displayLimitedData: true };
};

export const GetShortCampaignSamlpeData = async (req) => {
  try {
    const cachedData = readFromCache(getShortCampaignSamlpeData);

    if (cachedData) {
      return cachedData;
    }
    const response = await api.post(
      getShortCampaignSamlpeData,
      {},
      {
        cancelToken: req.cancelToken,
      },
    );
    writeToCache(getShortCampaignSamlpeData, response.data);
    if (response.status === API_CALL_SUCCESSFULL) {
      return response.data;
    }
    return [];
  } catch (e) {
    return false;
  }
};
